import { pdf } from '@react-pdf/renderer'

import { JourneyAnswersPdfDocument } from '../components/JourneyAnswersPdfDocument'
import type { JourneyAnswerExportRecord } from '../types/answer-export'

function sanitizeFileNamePart(value: string) {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9-_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase()
}

function buildFileName(data: JourneyAnswerExportRecord) {
  const journey = sanitizeFileNamePart(data.journey.title || 'jornada')
  const scope = data.scope === 'level' ? 'nivel' : 'consolidado'

  return `respostas-${journey}-${scope}.pdf`
}

export async function generateJourneyAnswersPdf(data: JourneyAnswerExportRecord) {
  const blob = await pdf(<JourneyAnswersPdfDocument data={data} />).toBlob()
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')

  anchor.href = url
  anchor.download = buildFileName(data)
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}
